<template>
  <div class="teacherPop">
    <div class="zzc" @click="hide()"></div>
    <div class="popContain">
      <img src="@/assets/close.png" class="closeIcon" @click="hide()" />
      <div class="info">
        <img :src="require('@/assets/' + item.pic)" class="avatar" />
        <div class="flexItem">
          <b>{{item.name}}</b>
          <span>{{item.from}}</span>
        </div>
      </div>
      <div class="desc">{{item.desc}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'teacherPop',
  props: ['item'],
  data() {
    return {
    }
  },
  methods: {
    hide() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.teacherPop{position: fixed;top: 0;left: 0;bottom: 0;right: 0;z-index: 9999;background-color: rgba(0,0,0,0.5);}
.popContain{width: 900px;max-height: 600px;background-color: #fff;border-radius: 8px;box-sizing: border-box;padding: 100px;overflow-y: auto;position: relative;top: 50%;left: 50%;margin-top: -300px;margin-left: -450px;z-index: 9999}
.zzc{position: fixed;top: 0;left: 0;bottom: 0;right: 0;z-index: 9000;}
.closeIcon{width: 24px;height: 24px;position: absolute;top: 40px;right: 40px;cursor: pointer;}
.info{margin-bottom: 60px;display: flex;flex-direction: row;align-items: center;}
.avatar{width: 140px;height: 140px;border-radius: 8px;margin-right: 32px;}
.flexItem{flex:1;}
.flexItem b{color: #222;font-size: 36px;font-weight: bold;margin-bottom: 20px;display: block;}
.flexItem span{color: #666;font-size: 20px;display: block;}
.desc{color: #666;font-size: 18px;line-height: 30px;}
</style>
